import "babel-polyfill";
import "./libs/slick"
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
// import "./libs/splitting";
// import "./libs/splitting-lite";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {mobileNav} from "./modules/mobileNav";
import {navSticky} from "./modules/navSticky";
import {scrollTop} from "./modules/scrollTop";
import {customSelect} from "./modules/customSelect";
import {newsroomSticky} from "./modules/newsroomSticky";
import {recognitionSlider} from "./modules/recognitionSlider";
import {leadershipSlider} from "./modules/leadershipSlider";
import {industriesSlider} from "./modules/industriesSlider";
import {pricingSolutionsSlider} from "./modules/pricingSolutionsSlider";
import {partnersReviewSlider} from "./modules/partnersReviewSlider";
import {interactiveMapSlider} from "./modules/interactiveMapSlider";
import {interactiveMap} from "./modules/interactiveMap";
import {partnersInfoNavSlider} from "./modules/partnersInfoNavSlider";
import {partnersInfoNumbersSlider} from "./modules/partnersInfoNumbersSlider";
import {partnersInfoItemSlider} from "./modules/partnersInfoItemSlider";
import {heroSlider} from "./modules/heroSlider";
import {scrollDown} from "./modules/scrollDown";
import {territoriesSlider} from "./modules/territoriesSlider";
import {heroHeadingAnimation} from "./modules/heroHeadingAnimation";
import {parallax} from "./modules/parallax";


binder({
    bounds: {
        "html": [constants, fullHeightPage],
        ".header": [mobileNav, navSticky],
        "select": customSelect,
        ".back-to-top": scrollTop,
        ".newsroom-contact-box": newsroomSticky,
        ".our-recognition": recognitionSlider,
        ".leadership": leadershipSlider,
        ".industries-slider": industriesSlider,
        ".pricing-solutions-slider": pricingSolutionsSlider,
        ".partners-review-slider": partnersReviewSlider,
        ".interactive-map-slider": interactiveMapSlider,
        ".interactive-map": interactiveMap,
        ".partners-info-nav": partnersInfoNavSlider,
        ".partners-info-numbers": partnersInfoNumbersSlider,
        ".partners-info-slider .item": partnersInfoItemSlider,
        ".hero-slider": heroSlider,
        ".scroll-down": scrollDown,
        ".territories-slider": territoriesSlider,
        ".title-animation": heroHeadingAnimation,
        ".parallax": parallax

    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js